<template>
  <div>
    <!-- 常规仓库 -->
    <baseBreadcrumb :page="$t('message.regularWarehouse')" :menu="$t('message.warehouse')"></baseBreadcrumb>
    <!-- 主体 -->
    <div class="body">
      <el-tabs v-model="datas.is_recent" type="card" @tab-click="handleClick">
        <!-- 全部 -->
        <el-tab-pane :label="$t('message.all')" name="0"></el-tab-pane>
        <!-- 近5天上架完-->
        <el-tab-pane :label="$t('message.inAbout5Days') + `(${tabs[1].num})`" name="5"></el-tab-pane>
        <!-- 近30天上架完-->
        <el-tab-pane :label="$t('message.inAbout30Days') + `(${tabs[2].num})`" name="1"></el-tab-pane>
        <!--  30天前上架完-->
        <el-tab-pane :label="$t('message.itWentOnTheShelves30DaysAgo') + `(${tabs[3].num})`" name="2"></el-tab-pane>
        <!--  90天前上架完-->
        <el-tab-pane :label="$t('message.itWentOnTheShelves90DaysAgo') + ``" name="3"></el-tab-pane>
      </el-tabs>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 物流号 -->
          <div class="item">
            <el-input v-model="datas.express_no" :placeholder="$t('message.logisticsNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 交易号 -->
          <div class="item">
            <el-input v-model="datas.purchase_no" :placeholder="$t('message.transactionNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 商品ID -->
          <div class="item">
            <el-input v-model="datas.goods_id" :placeholder="$t('message.goodsID')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 订单号 -->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderbianhao')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 客户ID -->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.userID')" clearable
              onfocus="this.select()"></el-input>
          </div>
            <!-- 是否Fba -->
          <div class="item">
            <el-select v-model="datas.is_fba" placeholder="是否FBA商品" filterable clearable >
              <el-option :label="'是'" :value="1">
              </el-option>
               <el-option :label="'否'" :value="0">
              </el-option>
            </el-select>
          </div>
          <!-- 客户标记筛选：接口约定 1 为退会客户，2 为半年未下单客户。 -->
          <div class="item">
            <el-select v-model="datas.client_mark" placeholder="客户标记" clearable>
              <el-option label="退会客户" :value="1" />
              <el-option label="半年未下单客户" :value="2" />
            </el-select>
          </div>
        </div>
        <div class="row">
            <!-- 时间选择 -->
          <div class="item">
            <el-select v-model="val" :placeholder="$t('message.timeType')" filterable clearable >
              <el-option v-for="item in timeOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 开始时间 -->
          <div class="item">
            <el-date-picker v-model="startDate" type="datetime" :placeholder="$t('message.startDate')"
              default-time="00:00:00" value-format="yyyy-MM-dd HH:mm:ss" :disabled="val == ''">
            </el-date-picker>
          </div>
          <!-- 结束日期 -->
          <div class="item">
            <el-date-picker v-model="dateClosed" type="datetime" :placeholder="$t('message.dateClosed')"
              default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss" :disabled="val == ''">
            </el-date-picker>
          </div>
          <!-- 采购 -->
          <div class="item">
            <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 业务 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 商品类型：未标识辅料的商品都视为常规商品 -->
          <div class="item">
            <el-select v-model="datas.material_filter"
              :placeholder="$t('message.productClassificationFiltering')">
              <el-option label="全部" value="0" />
              <el-option label="常规商品" value="1" />
              <el-option label="辅料" value="2" />
            </el-select>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.ok") }}
          </el-button>
          <!-- 重置 -->
          <!-- <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button> -->
        </div>
      </div>
      <!-- 操作 -->
      <div class="operation">

        <!-- 售中问题提出 -->
        <el-button type="primary" @click="issueSubmissionDuringSale" v-if="isAuth(621)">
          {{ $t("message.issueSubmissionDuringSale") }}
        </el-button>
        <!-- 提出配送单 -->
        <el-button type="primary" class="primary" @click="putForwardDeliveryOrder">
          {{ $t("message.putForwardDeliveryOrder") }}
        </el-button>
        <!-- 申请废弃 -->
        <el-button type="primary" class="primary" @click="petitionForAbandonment" v-if="isAuth(366)">
          {{ $t("message.petitionForAbandonment") }}
        </el-button>

        <!-- 移库 -->
        <el-button type="primary" class="primary" @click="moveTheLibrary" v-if="isAuth(365)">
          {{ $t("message.moveTheLibrary") }}
        </el-button>
        <!-- 导出 -->
        <el-button type="success" v-if="datas.is_recent > 1" @click="exportExcel">
          {{ $t("message.export") }}
        </el-button>
        <!-- @click="exportExcel" -->
        <!-- 直接装箱 -->
        <el-button type="primary" @click="directPacking" class="primary">
          {{ $t("message.directPacking") }}
        </el-button>
        <!--转入长存仓库  -->
        <!-- <el-button type="success" @click="transferToLongTermStorageWarehouse" class="primary">
          {{ $t("message.transferToLongTermStorageWarehouse") }}
        </el-button> -->

      </div>
      <!-- 列表 -->
      <div class="table" v-if="show" ref="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          ref="multipleTable" @cell-click="labelSelection" size="small" :max-height="tableautoheight">
          <el-table-column align="center" label="NO" width="45" prop="rowNumber" fixed="left">
            <template slot-scope="scope">
              <div class="template" style="text-align: center;">
                {{ scope.row.rowNumber }}
                <!-- 辅料标记来自订单商品的 is_material 字段 -->
                <el-tag v-if="Number(scope.row.order_purchase.order_detail.material_id) " size="mini" type="success">辅料</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="50" align="center" fixed="left">
            <!-- 全选 -->
            <template slot="header" slot-scope="scope">
              <el-checkbox v-model="checked" @change="arrChecked">
              </el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" @change="itemChecked">
              </el-checkbox>
            </template>
          </el-table-column>
          <!-- 库位 -->
          <el-table-column align="center" :label="$t('message.location')" width="100px">
            <template slot-scope="scope">
              <p>{{ scope.row.wms_grid.wms_shelf.area_type_code}}-{{ scope.row.grid_number.split("】-")[0] }}】-</p>
              <p style="color: #fa5058">
                {{ scope.row.grid_number.split("】-")[1] }}
              </p>
            </template>
          </el-table-column>
          <!-- 使用范围 -->
          <el-table-column align="center" :label="$t('message.scopeOfUse')" prop="wms_grid.wms_shelf.organization.name">
            <template slot-scope="scope">
              <p v-if="scope.row.wms_grid.wms_shelf.organization != null">
                {{ scope.row.wms_grid.wms_shelf.organization.name }}
              </p>
              <p v-if="scope.row.wms_grid.wms_shelf.admin != null">
                {{ scope.row.wms_grid.wms_shelf.admin.name }}
              </p>
            </template>
          </el-table-column>
          <!-- 细分区域备注 -->
          <el-table-column align="center" :label="$t('message.remarksOfSubdivisionRegion')" width="100px">
            <template slot-scope="scope">
              <p style="color:rgb(250, 80, 88);font-size:20px" v-if="scope.row.order_purchase.order.status == 70">
                可发货
              </p>
              <p>{{ scope.row.wms_grid.wms_shelf.remark }}</p>
            </template>
          </el-table-column>
          <!-- 入库时间 -->
          <el-table-column align="center" :label="$t('message.timeOfStorage')" prop="updated_at" width="76px">
            <template slot-scope="scope">
              <p>{{ scope.row.updated_at }}</p>
              <p v-if="scope.row.days_surplus_for_free !== ''">剩余保管</p>
              <p class="red" style="font-size: 12px;"> {{ scope.row.days_surplus_for_free === '' ? '订单未上完' :
                scope.row.days_surplus_for_free + '天' }} </p>
            </template>
          </el-table-column>
          <!-- 入金时间 -->
          <el-table-column align="center" :label="$t('message.timeOfPayment')"
            prop="order_purchase.order.order_time_node.datetime_pay_confirm" width="76px" v-if="datas.shelf_type != 2">
          </el-table-column>
          <!-- 上架完了时间 -->
          <el-table-column align="center" :label="$t('message.outOfShelfTime')"
            prop="order_purchase.order_detail.order_detail_time_node.datetime_store_complete"
            v-if="datas.shelf_type != 2" width="76px">
          </el-table-column>
          <!-- 订单编号 -->
          <el-table-column align="center" :label="$t('message.orderbianhao')" width="140px">
            <template slot-scope="scope">
              <p>
                <router-link :to="'/orderPaymentDetail?order_sn=' +
                  scope.row.order_purchase.order_sn
                  " target="_blank" style="color: #fa5058">{{ scope.row.order_purchase.order_sn }}</router-link>
              </p>
              <p>
                <router-link :to="'user/userWarehouse?userID=' + scope.row.order_purchase.order.user.id" target="_blank"
                  class="a-link">
                  {{ scope.row.order_purchase.order.user.realname }}</router-link>
              </p>
              <attributeName :name="scope.row.order_purchase.order.attribute_name" />
              <!-- 客户标记直接展示库存接口返回的 client_mark_names。 -->
              <div class="client-mark-list">
                <el-tag v-for="mark in scope.row.client_mark_names" :key="mark" size="mini"
                  :type="mark === '退会客户' ? 'danger' : 'warning'">
                  {{ mark }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <!-- 番号 -->
          <el-table-column align="center" :label="$t('message.mash')" width="50">
            <template slot-scope="scope">
              {{ scope.row.order_purchase.order_detail.sorting }}
              <!-- 查看配送单号 -->
              <el-popover placement="top-start" width="200" trigger="hover"
                v-if="scope.row.order_purchase.order_detail.porder_detail != false">
                <p v-for="(item, index) in scope.row.order_purchase.order_detail.porder_detail">{{ item.porder_sn }}</p>
                <img src="@/assets/icon/delivery.png" alt="" slot="reference" style="width: 30px;">
              </el-popover>
            </template>
          </el-table-column>
          <!-- 照片 -->
          <el-table-column align="center" :label="$t('message.pic')" prop="floor">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="scope.row.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${scope.row.order_purchase.order_detail.goods_id}.html`"
                  target="_blank" slot="reference">
                  <img :src="scope.row.order_purchase.order_detail.pic" alt="" style="width: 60px; height: 60px" />
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <!-- 商品属性 -->
          <el-table-column align="center" :label="$t('message.commodityAttribute')">
            <template slot-scope="scope">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.order_purchase
                      .order_detail.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.order_purchase
                      .order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- 入金后数量 -->
          <el-table-column align="center" :label="$t('message.amountAfterGol')">
            <template slot-scope="scope">
              <div class="template">
                <div class="template">
                  <!-- 可入库 -->
                  <p>
                    {{ $t("message.canBePutIntoStorage") }}:{{
                      scope.row.order_purchase.possible_num
                    }}
                  </p>
                  <!-- 已到货 -->
                  <p>
                    {{ $t("message.itHasArrived") }}:{{
                      scope.row.order_purchase.storage_num
                    }}
                  </p>
                  <!-- 已出货 -->
                  <p>
                    {{ $t("message.shipped") }}:{{
                      scope.row.order_purchase.p_num
                    }}
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 已提出配送单数 -->
          <el-table-column align="center" :label="$t('message.numberOfDeliveryOrdersProposed')">
            <template slot-scope="scope">
              {{ scope.row.order_purchase.p_detail_created_num }}
            </template>
          </el-table-column>
          <!-- 库位数 -->
          <el-table-column align="center" :label="$t('message.numberOfLibraryPositions')" prop="num">
          </el-table-column>
          <!-- 可移库数 -->
          <el-table-column align="center" :label="$t('message.numberOfRemovableLibraries')" prop="can_move_num"
            v-if="datas.shelf_type != 2">
          </el-table-column>
          <!-- 单价(元) -->
          <el-table-column align="center" :label="datas.shelf_type != 3 ? '单价.元' : '单价'"
            prop="order_purchase.order_detail.confirm_price">
          </el-table-column>
          <!-- 交易号/物流号 -->
          <el-table-column align="center" :label="$t('message.transactionNumberLogisticsNumber')" width="180px"
            v-if="datas.shelf_type != 2">
            <template slot-scope="scope">
              <div class="template">
                <p>JY：{{ scope.row.order_purchase.purchase_no }}</p>
                <p v-for="(item, index) in scope.row.order_purchase
                  .order_purchase_express" :key="index">
                  WL{{ index + 1 }}：{{ item.express_no }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 业务商品备注 -->
          <el-table-column align="center" :label="$t('message.serviceRemarks')"
            prop="order_purchase.order_detail.y_remark" width="120px">
          </el-table-column>
          <!-- 业务跟进备注 -->
          <el-table-column align="center" :label="$t('message.businessFollowUpNotes')" width="120px">
            <template slot-scope="scope">
              <textarea v-model="scope.row.order_purchase.order_detail.order_detail_follow_remark.y_remark"
                @blur="updateFollowYRemark(scope.row)"></textarea>
            </template>
          </el-table-column>
          <!-- 订单操作人员 -->
          <el-table-column align="center" :label="$t('message.orderOperato')" width="120">
            <template slot-scope="scope">
              <div class="template">
                <p>
                  {{ $t("message.salesman") }}:{{
                    scope.row.order_purchase.order.y_admin ? scope.row.order_purchase.order.y_admin.realname : ''
                  }}
                </p>
                <p>
                  {{ $t("message.buyer") }}:{{
                    scope.row.order_purchase.order.g_admin ? scope.row.order_purchase.order.g_admin.realname : ''
                  }}
                </p>
                <p>
                  {{ $t("message.distributionMember") }}:{{
                    scope.row.order_purchase.order.p_admin ? scope.row.order_purchase.order.p_admin.realname : ''
                  }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 废弃商品处理备注 -->
          <el-table-column align="center" :label="$t('message.disposedProductRemarks')" width="120px"
            v-if="datas.shelf_type == 2">
            <template slot-scope="scope">
              <textarea v-model="scope.row.discard_remark" @blur="discardDealRemarkSet(scope.row)"
                v-if="isAuth(612)"></textarea>
              <p v-else>{{ scope.row.discard_remark }}</p>
            </template>
          </el-table-column>
          <!-- 行政处理方案 -->
          <el-table-column align="center" :label="$t('message.administrativeHandlingPlan')" prop="discard_type"
            v-if="datas.shelf_type == 2">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" fixed="right" width="100">
            <template slot-scope="scope">
              <!-- 商品备注 -->
              <el-button size="mini" type="primary" class="primary" @click="lookRemark(scope.row)">
                {{ $t("message.commodityNote") }}
              </el-button>
              <p style="margin-top: 10px;">
                <!-- 处理商品 -->
                <el-button size="mini" type="success" @click="processProducts(scope.row)"
                  v-if="datas.shelf_type == 2 && !scope.row.discard_type">
                  {{ $t("message.processProducts") }}
                </el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[200, 300, 400]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 商品废弃 -->
    <wasteGoods v-if="wasteGoodsDialogVisible" :list="selectList" :type="'add'" />
    <!-- 商品备注 -->
    <commodityNote v-if="commodityNoteDialogVisible" :commodityNoteData="commodityNoteData" />
    <!-- 箱子备注 -->
    <boxRemark v-if="boxRemarkDialogVisible" :boxRemarksData="boxRemarksData" :title="'箱子备注编辑'" />
    <!-- 移库 -->
    <moveTheLibrary v-if="moveTheLibraryDialogVisible" :list="selectList" />
    <!-- 仓库 -->
    <warehouse v-if="warehouseDialogVisible" :yiku_data="moveTheLibraryList" :shelf_type_set="shelf_type_set"
      :boxIds="boxIds" :type="warehouseType" />
    <!-- 装箱详情 -->
    <movingGoodsBox ref="movingGoodsBox" :box_id="box_id" />
    <!-- 商品标记设置 -->
    <productMarkingSettings ref="productMarkingSettings" />
    <!-- 处理商品 -->
    <processProducts ref="processProducts" />
    <!-- 售中问题产品 -->
    <inSalePreview ref="inSalePreview" />
    <!-- 转库单提出 -->
    <transferToLongTermStorageWarehouse ref="transferToLongTermStorageWarehouse" />
    <directPacking ref="directPacking" @success="directPackingSuccess" />
  </div>
</template>
<script>
import wasteGoods from "../components/wasteGoods";
import commodityNote from "@/components/common/commodityNote";
import boxRemark from "../components/boxRemark";
import warehouse from "@/components/common/warehouse";
import moveTheLibrary from "../components/moveTheLibrary";
import movingGoodsBox from "../components/movingGoodsBox";
import { timeDifference } from '@/utlis/date'
import productMarkingSettings from '../components/productMarkingSettings'
import processProducts from '../components/processProducts'
import inSalePreview from '@/components/inSale/inSalePreview'
import transferToLongTermStorageWarehouse from '../components/transferToLongTermStorageWarehouse'
import directPacking from '../components/directPacking'
export default {
  components: {
    wasteGoods,
    commodityNote,
    boxRemark,
    warehouse,
    moveTheLibrary,
    movingGoodsBox,
    productMarkingSettings,
    processProducts,
    inSalePreview,
    transferToLongTermStorageWarehouse,
    directPacking
  },
  data() {
    return {
      tableautoheight: window.innerHeight > 800 ? window.innerHeight - 180 : 800,
      show: false,
      checked: false,//全选
      datas: {
        admin_id: "",
        shelf_type: "1",
        is_recent: "0",
        material_filter: "0",
        client_mark: "",
        pageSize: 200,
        page: 1,
      },
      val: "", //时间类型
      startDate: "", //开始时间
      dateClosed: "", //结束时间
      timeOption: [
        { value: 1, label: "入金时间" },
        { value: 2, label: "入库时间" },
        { value: 3, label: "上架完了" },
      ],
      userList: [],
      tableData: [],
      total: 0,
      selectList: [],
      wasteGoodsDialogVisible: false, //商品废弃
      boxRemarkDialogVisible: false, //箱子备注
      boxRemarksData: {}, //箱子备注
      commodityNoteDialogVisible: false, //商品备注
      commodityNoteData: {}, //商品备注
      moveTheLibraryDialogVisible: false, //移库
      moveTheLibraryList: [],
      warehouseDialogVisible: false, //仓库
      shelf_type_set: [1, 2, 3],
      box_id: 0,
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 }, { num: 0 },],
      // 退回常规仓库
      boxIds: [],
      warehouseType: 0,
      labelList: [],//标签列表
      rowLabelList: [],//每行显示的标签
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },

  },
  created() {
    if (this.$route.query.user_id) {
      this.datas.user_id = this.$route.query.user_id
    }
    this.wmsStockListNum()
    this.stockList()
  },
  methods: {
    // 标签列表
    labelConfigList() {
      this.$api.warehouseApi.labelConfigList().then((res) => {
        res.data.forEach(item => {
          item.checked = false
        })
        this.labelList = res.data
        this.rowLabelList = JSON.parse(JSON.stringify(res.data))
        this.stockList();
      })
    },
    // 常规,辅料,备品
    stockList() {
      this.selectList = []
      this.$api.warehouseApi.stockList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.checked = false
          item.real_num = item.can_discard_num;
          item.yiku_num = item.num;
          item.reason = "";
          item.images = ["", "", "", ""];
          item.timeDifference = timeDifference(item.updated_at, 60)
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
      });
    },
    // 常规,辅料,备品
    stockListCharge() {
      this.$api.warehouseApi.stockListCharge(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
      });
    },
    // 区别请求接口
    handleClick() {
      this.show = false;
      this.datas.datetime_pay_confirm_start = "";
      this.datas.datetime_pay_confirm_end = "";
      this.datas.stock_start = "";
      this.datas.stock_end = "";
      this.datas.store_complete_start = "";
      this.datas.store_complete_end = "";
      if (this.val == 1) {
        this.datas.datetime_pay_confirm_start = this.startDate;
        this.datas.datetime_pay_confirm_end = this.dateClosed;
      } else if (this.val == 2) {
        this.datas.stock_start = this.startDate;
        this.datas.stock_end = this.dateClosed;
      } else if (this.val == 3) {
        this.datas.store_complete_start = this.startDate;
        this.datas.store_complete_end = this.dateClosed;
      }

      this.stockList();
      this.wmsStockListNum()
    },
    //常规,辅料,备品 统计
    wmsStockListNum() {
      this.$api.tabTotalApi.wmsStockListNum({ shelf_type: this.datas.shelf_type }).then(res => {
        this.tabs = res.data
      })
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.admin_id = "";
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.handleClick();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.handleClick();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.handleClick();
    },
    // 重置
    reset() {
      this.startDate = "";
      this.dateClosed = "";
      this.datas = {
        page: 1,
        pageSize: 200,
        shelf_type: "1",
        express_no: "",
        purchase_no: "",
        goods_id: "",
        order_sn: "",
        user_id: "",
        datetime_pay_confirm_start: "",
        datetime_pay_confirm_end: "",
        stock_start: "",
        stock_end: "",
        org_id: "",
        admin_id: "",
        store_complete_start: "",
        store_complete_end: "",
        is_recent: "0",
        material_filter: "0",
        client_mark: "",
      };
      this.$refs.cascader.orgId = [];
      this.userList = [];
      this.val = "";
      this.$forceUpdate();
      this.handleClick();
    },

    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 申请废弃
    petitionForAbandonment() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.wasteGoodsDialogVisible = true;
    },
    // 清理
    toClear() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        ids: [],
      };
      this.selectList.forEach((item) => {
        datas.ids.push(item.id);
      });
      this.$confirm(this.$t("message.isRemove"), this.$t("message.hint"), {
        confirmButtonText: this.$t("message.ok"), //确定
        cancelButtonText: this.$t("message.cancel"), //取消
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.warehouseApi.toClear(datas).then((res) => {
            this.$message.success(res.msg);
            this.handleClick();
          });
        })
        .catch(() => { });
    },
    //查看备注
    lookRemark(item) {
      this.commodityNoteData = {
        p_remark: item.order_purchase.order_detail.p_remark,
        g_remark: item.order_purchase.order_detail.g_remark,
        y_remark: item.order_purchase.order_detail.y_remark,
      };
      this.commodityNoteDialogVisible = true;
    },
    //箱子备注
    boxRemarks(item) {
      this.boxRemarksData = {
        y_remark: item.y_remark,
        p_remark: item.p_remark,
        box_id: item.id,
      };
      this.boxRemarkDialogVisible = true;
    },
    //移库
    moveTheLibrary() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.moveTheLibraryDialogVisible = true;
      this.warehouseType = 0
    },
    // 需要移库的
    getmoveTheLibraryList(data) {
      this.moveTheLibraryList = data;
      this.moveTheLibraryDialogVisible = false;
      this.warehouseDialogVisible = true;
    },
    // 移库成功
    stockMoveSuccess() {
      this.warehouseDialogVisible = false;
      this.handleClick();
    },

    //接收回退常规仓库函数 勿删
    boxList() {
      this.warehouseDialogVisible = false;
      this.handleClick();
    },
    //直接装箱
    directPacking() {
      if (!this.selectList || this.selectList.length == 0) {
        return this.$message.error("请选择商品后再进行操作");
      }
      this.$refs.directPacking.init(this.selectList)
    },
    directPackingSuccess() {
      this.handleClick();

    },
    // 导出
    exportExcel() {
      let datas = JSON.parse(JSON.stringify(this.datas))
      datas.page = 1
      datas.is_export = 1
      datas.pageSize = 999999
      this.$api.warehouseApi.stockList(datas).then((res) => {
        const a = document.createElement('a');
        const href = res.data
        a.href = href;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); // 下载完移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      });
    },
    //提出配送单
    putForwardDeliveryOrder() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let itemData = this.selectList[0];
      let flag = this.selectList.every(
        (item) =>
          item.user_id == itemData.user_id
      );
      if (!flag)
        return this.$alert("只能同一个客户的商品才能提出配送单", "提示", {
          confirmButtonText: "确定",
          center: true,
        });
      let ids = []
      // ?id=13928943,13928945&userID=71
      this.selectList.forEach(item => {
        ids.push(item.order_detail_id)
      })
      let routeUrl = this.$router.resolve({
        path: `/deliveryPreview?id=${ids.join(',')}&userID=${itemData.user_id}`,
      });
      window.open(routeUrl.href, JSON.stringify(itemData));
      console.log(this.selectList);
    },
    // 商品标记设置
    productMarkingSettings() {
      this.$refs.productMarkingSettings.dialogVisible = true
    },
    //显示标签
    setRowLabelList(row) {
      this.rowLabelList.forEach(item => {
        item.checked = false
      })
      row.order_detail_label.forEach(item => {
        this.rowLabelList.forEach(items => {
          if (item.label_id == items.id || item.id == items.id) {
            items.checked = true
          }
        })
      })
      this.$forceUpdate()
    },
    //全选
    arrChecked() {
      this.selectList = []
      this.tableData.forEach(item => {
        item.checked = this.checked
        if (this.checked) {
          this.selectList.push(item)
        }
      })
      this.$forceUpdate()
    },
    //单选
    itemChecked() {
      this.selectList = []
      this.tableData.forEach(item => {
        if (item.checked) {
          this.selectList.push(item)
        }
      })
      this.checked = this.tableData.every(item => item.checked)
      this.$forceUpdate()
    },
    //商品标记-配置-批量打标
    batchSetLabel(row, index) {
      let datas = {
        order_detail_ids: [],
        label_ids: [],
      }
      let checkedLabel = []
      this.rowLabelList.forEach(item => {
        if (item.checked) {
          datas.label_ids.push(item.id)
          checkedLabel.push(item)
        }
      })
      // 区别批量或者单个的
      if (row.checked) {
        this.tableData.forEach(item => {
          if (item.checked) {
            datas.order_detail_ids.push(item.order_detail_id)
          }
        })
      } else {
        datas.order_detail_ids = [row.order_detail_id]
      }
      this.$api.warehouseApi.batchSetLabel(datas).then(res => {
        this.$message.success(res.msg)
        // 页面直接修改标签
        if (row.checked) {
          this.tableData.forEach(item => {
            if (item.checked) {
              item.order_detail_label = checkedLabel
            }
          })
        } else {
          this.tableData[index].order_detail_label = checkedLabel
        }
        this.$forceUpdate()
      })
    },
    //商品跟进-修改业务跟进备注
    updateFollowYRemark(row) {
      console.log(row);
      let datas = {
        order_detail_id_set: [row.order_purchase.order_detail.id],
        y_remark: row.order_purchase.order_detail.order_detail_follow_remark.y_remark
      }
      this.$api.orderApi.updateFollowYRemark(datas)
    },
    //备品仓库-设置处理备注
    discardDealRemarkSet(row) {
      let datas = {
        stock_id: row.id,
        discard_remark: row.discard_remark
      }
      this.$api.warehouseApi.discardDealRemarkSet(datas)
    },
    //处理商品
    processProducts(row) {
      this.$refs.processProducts.datas = {
        stock_id: row.id,
        discard_type: '废弃',
      }
      this.$refs.processProducts.dialogVisible = true
    },
    //售中问题提出
    issueSubmissionDuringSale() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let ids = []
      this.selectList.forEach(item => {
        ids.push(item.order_purchase.order_detail_id)
      })
      this.$refs.inSalePreview.storePreview(ids)
    },
    // 售中问题产品提出成功
    problemStoreSuccess() {
      this.handleClick();
    },
    // 转入长存仓库
    transferToLongTermStorageWarehouse() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.transferToLongTermStorageWarehouse.list = []
      this.selectList.forEach(item => {
        let itemData = JSON.parse(JSON.stringify(item))
        itemData.yiku_num = itemData.can_move_num
        this.$refs.transferToLongTermStorageWarehouse.list.push(itemData)
      })

      this.$refs.transferToLongTermStorageWarehouse.datas = {
        pack_by: "",
        remark: "",
        target_shelf_type: "4"
      }
      this.$refs.transferToLongTermStorageWarehouse.dialogVisible = true
    },
  },
};
</script>
<style lang='scss' scoped>
.nav {
  display: flex;
  margin-bottom: 24px;

  .item {
    width: 160px;
    height: 48px;
    line-height: 48px;
    border: 2px solid #b4272d;
    color: #b4272d;
    font-size: 18px;
    text-align: center;
    border-right: 0;

    &:nth-child(1) {
      border-radius: 4px 0px 0px 5px;
    }

    &:nth-last-child(1) {
      border: 2px solid #b4272d;
      border-radius: 0px 4px 5px 0px;
    }

    cursor: pointer;
  }

  .index {
    background-color: #b4272d;
    color: #fff;
  }
}

.search {
  margin-top: 10px;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 180px;
      margin-right: 24px;
    }

    /deep/.el-date-editor {
      width: 100%;

      .el-input__inner {
        padding-right: 0;
      }
    }
  }
}

// 订单编号列中的客户标记纵向排列，避免两个标记在窄列内相互挤压。
.client-mark-list {
  display: flex;
  flex-direction: column;
  align-items: center;

  .el-tag {
    margin-top: 4px;
  }
}

.operation {
  margin-bottom: 24px;
  text-align: right;
}

.template {
  width: 100%;
  text-align: left;
}

.price-tag {
  position: relative;

  .el-icon-price-tag {
    cursor: pointer;
    color: #b4272d;
    font-size: 25px;
    transform: rotate(-30deg)
  }
}

/deep/.cell {
  padding: 0 3px !important;
}

/deep/.el-checkbox {
  line-height: 40px;
  min-height: 40px;
  min-width: 40px;
}

textarea {
  min-height: 100px !important;
  padding: 3px;
  border: 1px solid #E4E7ED;
  width: 95%;
  border-radius: 4px;
  resize: none;
}
</style>
